import { AbstractControl, FormGroup, ValidatorFn } from "@angular/forms";

export class CustomValidator {
  // Validates URL
  static checkAccountNo(group: FormGroup) {
    // here we have the 'passwords' group
    const pass = group.controls.accountNumber.value;
    const confirmPass = group.controls.cAccountNumber.value;
    return pass === confirmPass ? null : { notSame: true };
  }

  static checkPassword(group: FormGroup) {
    // here we have the 'passwords' group
    const pass = group.controls.passowrd.value;
    const confirmPass = group.controls.cPassowrd.value;
    return pass === confirmPass ? null : { notSame: true };
  }

  static maxDate(yearCount: number): ValidatorFn {
    // here we have the 'passwords' group
    return (currentControl: AbstractControl): { [key: string]: any } => {
      if (currentControl.value) {
        const year = new Date().getFullYear() - yearCount;
        let month: any = new Date().getMonth() + 1;
        month = month.toString().length === 1 ? "0" + month : month;
        let date1: any = new Date().getDate();
        date1 = date1.toString().length === 1 ? "0" + date1 : date1;
        const max = year + "-" + month + "-" + date1;
        return max >= currentControl.value ? null : { invalidDob: true };
      }
    };
  }
}

export class AppConfig {
  public static webUrl = "https://www.myteam11.com/";
  public static config = {
    version: "1",
    appType: "3",
  };
  public static colorList = [
    { id: 1, safe: "#1141c1", regular: "#7B0041", isActive: true },
    { id: 2, safe: "#3859FF", regular: "#FB5301", isActive: false },
    { id: 3, safe: "#0E449E", regular: "#ba0032", isActive: false },
    { id: 4, safe: "#03A0FF", regular: "#FFAA00", isActive: false },
    { id: 5, safe: "#AD63FF", regular: "#FE6464", isActive: false },
  ];
}

export class StaticKeys {
  public fixture = "notstarted";
  public live = "started";
  public results = "completed";
}

export enum MatchType {
  cricket = 1,
  football = 2,
  kabaddi = 3,
  volleyball = 4,
  nba = 5,
  hockey = 6,
  quiz = 7,
  baseball = 8,
  handball = 9,
  rugby = 10,
  usfootball = 11,
}

export enum ProfileTab {
  wallet,
  verify,
  refer,
  rank,
  info,
}

export enum MatchMode {
  regular = 1,
  safe = 2,
}

export enum PlayerPost {
  captain = "2",
  viceCaptain = "1.5",
  player = "p",
  x3 = "3",
  x4 = "4",
}

export class SortTypePlayer {
  public teamName = "TeamShortCode";
  public playerName = "PlayerName";
  public point = "PlayerPoint";
  public credits = "Credits";
  public selectedBy = "SelectedPrec";
  public isXi = "IsXi";
}

export class EventPrefixValue {
  public static myContest = "MyContest";
  public static yes = "Yes";
  public static no = "No";
  public static onboarding = "Onboarding";
  public static homeScreen = "Home Screen";
  public static contestScreen = "Contest Screen";
  public static wallet = "Wallet";
  public static more = "More";
  public static gmail = "Gmail";
  public static fb = "FB";
  public static email = "Email";
  public static login = "Login";
  public static sendOTP = "SendOTP";
  public static signup = "Register";
  public static mobile = "Mobile";
  public static safe = "Safe";
  public static regular = "Regular";
  public static pan = "PAN";
  public static accNo = "Account Number";
  public static teamName = "TeamName";
  public static forgetPassword = "ForgetPassword";
  public static sideMenu = "SideMenu";
  public static feedback = "Feedback";
  public static buttonClicked = "ButtonClicked";
  public static verifyOTP = "VerifyOTP";
  public static ResendOTP = "ResendOTP";
  public static loginWIthPhone = "LoginWithPhone";
  public static ReferEarn = "ReferAndEarn";
  public static goldenTicket = "GoldenTicket";
  public static leaderBoard = "Leaderboard";
  public static poll = "Poll";
  public static support = "Support";
  public static sportsTiger = "SportsTiger";
  public static setting = "Setting";
  public static liveChat = "LiveChat";
  public static notification = "Notification";
  public static avtaar = "Avtaar";
  public static editProfile = "EditProfile";
  public static profile = "Profile";
  public static home = "Home";
  public static faq = "FAQs";
  public static helpDesk = "HelpDesk";
  public static emailUs = "EmailUs";
  public static chatwithus = "ChatWithUs";
  public static facebook = "Facebook";
  public static twitter = "Twitter";
  public static instagram = "Instagram";
  public static youTube = "YouTube";
  public static loginWithEmail = "LoginWithEmail";
  public static referCode = "ReferCode";
  public static contestList = "ContestList";
  public static privateContest = "PrivateContest";
  public static createprivateContest = "CreatePrivateContest";
  public static privatecontestPopup = "PrivateContestPopup";
  public static viewStatement = "ViewStatement";
  public static addcash = "AddCash";
  public static scratchCards = "ScratchCards";
  public static withdrawMoney = "WithdrawMoney";
  public static myteam11Credit = "MyTeam11Credit";
  public static aboutUs = "AboutUs";
  public static myteam11Blog = "MyTeam11Blog";
  public static howtoPlay = "HowToPlay";
  public static fantasypointSystem = "FantasyPointSystem";
  public static tutorialVideos = "TutorialVideos";
  public static contestdetails = "ContestDetails";
  public static redeemCoupon = "RedeemCoupon";
  public static updateVerificationDetails = "UpdateVerificationDetails";
  public static redeemCouponDone = "RedeemCopounDone";
  public static redeemCouponPopup = "RedeemCopounPopup";
  public static referNewFriend = "ReferNewFriend";
  public static bannerClicked = "BannerClicked";
  public static matchClicked = "MatchClicked";
  public static compareTeam = "CompareTeam";
  public static joinContest = "JoinContest";
  public static joinConfirmation = "JoinConfirmation";
  public static cvcSelection = "CAndVCSelection";
  public static joinContestClicked = "JoinContestClicked";
  public static contestShare = "ContestShare";
  public static teampdfDownload = "TeamPDFDownload";
  public static mainTabClicked = "MainTabClicked";
  public static addCashRS = "AddCashRS";
  public static tabClicked = "TabClicked";
  public static myContestTabClicked = "MyContestTabClicked";
  public static myContestDetail = "MyContestDetail";
  public static passPurchased = "PassPurchased";
  public static inningTypeClicked = "InningTypeClicked";
  public static liveFantasy = "LiveFantasy";
  public static teamList = "TeamList";
  public static needHelp = "NeedHelp";
  public static teamPreview = "TeamPreview";
  public static termsAndConditions = "TermsAndConditions";
  public static privacyPolicy = "PrivacyPolicy";
  public static legalities = "Legalities";
  public static joinPrivateContestClicked = "JoinPrivateContestClicked";
  public static addCashClicked = "AddCashClicked";
  public static buyNowGoldenTicket = "BuyNowGoldenTicket";
  public static settings = "Settings";
  public static withdrawMoneyClicked = "WithdrawMoneyClicked";
  public static withdraw = "Withdraw";
  public static teamClone = "TeamClone";
  public static teamEdit = "TeamEdit";
  public static switchTeam = "SwitchTeam";
  public static pdfDownload = "PdfDownload";
  public static profileUpdate = "ProfileUpdate";
  public static scratchCardDone = "ScratchCardDone";
  public static viewAllWallet = "ViewAllWallet";
  public static payment = "Payment";
  public static submitFeedback = "SubmitFeedback";
  public static registerLogin = "Register-Login";
  public static switchTeamDone = "SwitchTeamDone";
  public static addCashClicks = "AddCashClicked";
  public static signIn = "SignIn";
  public static createNewPassword = "CreateNewPassword";
  public static createPassword = "CreatePassword";
  public static appOpened = "AppOpened";
  public static blockScreen = "BlockScreen";
  public static callUs = "CallUs";
  public static raiseARequest = "RaiseARequest";
  public static screenLoadDone = "ScreenLoadDone";
  public static addressVerification = "AddressVerification";
  public static aadhaarCard = "AadhaarCard";
  public static drivingLicence = "drivingLicence";
  public static favouriteContest = "Favourite";
  public static verifyEmail = "VerifyEmail";
  public static verification = "Verification";
  public static verifyOtp = "VerifyOtp";
  public static sportsTypeChange = "SportsTypeChange";
  public static viewOtherMethods = "ViewOtherMethods";
  public static hideMethods = "HideMethods";
  public static verifyAadharViaOtp = "VerifvAadhaarViaOTP";
  public static uploadDrivingLicence = "UploadDrivinglicense";
  public static uploadAadhar = "UploadAadhaar";
  public static addressVerificationContinue = "AddressVerificationContinue";
  public static tryAgain = "TryAgain";
  public static tdsCertificate = "TDSCertificate";
  public static downloadAllQuarter = "DownloadAllQuarter";
}

export class ProfileEventName {
  public static name9 = "LogOutFromAllDevices"; // green mark
  public static name10 = "LogOut"; // green mark
  public static name11 = "PaymentDone"; // green mark
}

export class LoginEventName {
  public static name1 = "LandingRedirection"; // green mark
  public static name8 = "UserLogin"; // green mark
  public static name9 = "UserRegister"; // green mark
  public static name10 = "SelectLanguage"; // doubt
  public static name20 = "ButtonClicked"; // green mark
  public static name22 = "LogOut";
}

export class ContestModule {
  public static name1 = "CreateTeamClicked"; // green mark
  public static name6 = "JoinContestClicked"; // green mark
  public static name13 = "JoinContest"; // green mark
  public static name22 = "SaveTeam"; // green mark
  public static name28 = "CreatePrivateContestDone"; // red mark
  public static name35 = "SportsTypeChange"; // green mark
  public static name3 = "AddCashClicked";
  public static name41 = "CreatePrivateContest";
}

declare global {
  interface Number {
    playerType(): string;
    sportType(): string;
  }
}

const params: any = {
  CreateApplicationRequest: {
    /* required */ Name: "eve_name" /* required */,
    tags: {
      name: "pankaj",
      date: new Date(),
      /* '<__string>': ... */
    },
  },
  /** input parameters */
};

Number.prototype.playerType = function (): string {
  if (this === MatchMode.regular) {
    return "Regular";
  } else if (this === MatchMode.safe) {
    return "Safe";
  }
};
Number.prototype.sportType = function (): string {
  if (this === MatchType.cricket) {
    return "Cricket";
  } else if (this === MatchType.football) {
    return "Football";
  } else if (this === MatchType.kabaddi) {
    return "Kabaddi";
  } else if (this === MatchType.volleyball) {
    return "Volleyball";
  } else if (this === MatchType.nba) {
    return "Basketball";
  } else if (this === MatchType.hockey) {
    return "Hockey";
  } else if (this === MatchType.baseball) {
    return "Baseball";
  } else if (this === MatchType.rugby) {
    return "Rugby";
  } else if (this === MatchType.handball) {
    return "Handball";
  } else if (this === MatchType.quiz) {
    return "Quiz";
  } else if (this === MatchType.usfootball) {
    return "USA Football";
  }
};
